<template>
  <div>
    <div style="display: flex; width: 100%; justify-content: space-between; ">
      <div style="padding-bottom: 2rem;">
        <div style="display: flex; justify-content: start; gap: 0.5rem;" title="Search by App name">
          <div class="filter-bar" style="gap: 0.5rem; display: flex; align-items: center;">
            <input type="text" v-model="searchQuery" class="form-control" placeholder="Search by app name"
              @keyup.enter="handleSearch">
            <button class="btn btn-primary" @click="handleSearch" :disabled="isLoading">
              <i class="fa fa-search"></i>
            </button>
          </div>
          <div class="filter-bar" style="gap: 0.5rem;">
            Filter By:
            <b-dropdown variant="info" id="dropdown-1" right :text="filterText" class="btn"
              style="background-color: #17a2b8">
              <b-dropdown-item v-for="(filter, i) in filters" :key="filter" @click="changeFilter(i)">{{ filter
              }}</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>
      <div>
        <div style="justify-content: end; gap: 0.5rem; display: flex;">
          <div class="filter-bar" style="gap: 0.5rem;">
            Page Size:
            <b-dropdown variant="info" id="dropdown-1" :text="pageSize.toString()" class="btn"
              style="background-color: #17a2b8">
              <b-dropdown-item v-for="page in pageSizes" :key="page" @click="changePage(page)">{{ page
              }}</b-dropdown-item>
            </b-dropdown>
          </div>
          <button type="submit" class="btn btn-primary" title="prev" :disabled="page - 1 > -1 ? false : true"
            @click="prevPage()">Previous page</button>
          <button type="submit" class="btn btn-primary" title="next"
            :disabled="totalCount > (page + 1) * pageSize ? false : true" @click="nextPage()">Next page</button>
        </div>
      </div>
    </div>
    <div class="text-right"><b>Total Reviews:</b> {{ totalCount }}</div>
    <b-table :items="ratings" :fields="fields" :busy="isLoading" show-empty bordered striped head-variant="dark"
      style="text-align: left" class="flex w-full" @sort-changed="onSort">
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle  pr-2"></b-spinner>
          <strong>Loading..</strong>
        </div>
      </template>
      <template #empty>
        <div class="text-center text-danger my-2">
          No data found
        </div>
      </template>

          <template #cell(reviewDate)="row">
           <div class="w-full"> <span>{{ formatTime(row.item.createdAt) }}</span>
            <div><i class="fa fa-info-circle" aria-hidden="true" v-b-popover.hover="`Name: ${row.item.oauthclients?.name}, Private: ${row.item.oauthclients?.private}, isWhiteLabelFriendly: ${row.item.oauthclients?.isWhiteLabelFriendly}`" title="App Details"></i></div>
            </div>
          </template>

      <template #cell(user)="row">
        <div class="w-full">
          <div class="flex pb-2 w-full">
            <div class="truncate toCapitalFirst">{{ row.item.name }}</div>
          </div>
          <div class="pb-2 w-full"><b class="toCapitalFirst">{{ row.item.accountType }}</b></div>
          <div class="pb-2 w-full">{{ row.item.userId }}</div>
        </div>
      </template>

          <template #cell(appName)="row">
            <div>{{ row.item.oauthclients?.name }}</div>
          </template>

          <template #cell(totalInstallations)="row">
            <div>{{ row.item.oauthclients?.totalInstallations || 0 }}</div>
          </template>

      <template #cell(rating)="row">
        <div>{{ row.item.rating }}/5</div>
      </template>

      <template #cell(title)="row">
        <div style="width: 150px;">
          <div class="w-full">{{ row.item.title }}</div>
        </div>
      </template>

      <template #cell(desc)="row">
        <div style="width: 500px">
          <div class="w-full" style="word-wrap: break-word;"> {{ row.item.review }}</div>
        </div>
      </template>

      <template #cell(aiAnalysis)="row">
        <div class="w-full">
          <button v-if="row.item.aiAnalysis" class="btn btn-info btn-sm" @click="openAiAnalysisModal(row.item)"
            title="View AI Analysis">
            <i class="fa fa-eye"></i> View
          </button>
          <span v-else class="text-muted">N/A</span>
        </div>
      </template>

      <template #cell(status)="row">
        <div class="w-full position-center">
          <div v-if="row.item.deleted === false && row.item.isLive === true" class="tag success subtitle-font p-1 flex"
            style="padding-inline: 0.5rem;">Approved</div>
          <div v-else-if="row.item.deleted === true && row.item.isLive === false"
            class="tag danger subtitle-font p-1 flex" style="padding-inline: 0.5rem;">Disapproved</div>
          <div v-else-if="row.item.deleted === false && row.item.isLive === false"
            class="tag info subtitle-font p-1 flex" style="padding-inline: 0.5rem;">Pending</div>
        </div>
      </template>
      <template #cell(action)="row">
        <div v-if="processing"><b-spinner class="align-middle"></b-spinner></div>
        <div v-else style="display: flex; justify-content: start;gap: 0.5rem;">
          <button id="disapprove-review" class="btn info-btn"
            :disabled="(row.item.deleted === false && row.item.isLive === true) || (row.item.deleted === true && row.item.isLive === false)"
            @click="updateStatus(row.item, 'disapproved')" size="sm">Disapprove</button>
          <button id="approve-review" class="btn btn-primary"
            :disabled="(row.item.deleted === false && row.item.isLive === true) || (row.item.deleted === true && row.item.isLive === false)"
            @click="updateStatus(row.item, 'approved')" size="sm">Approve</button>
        </div>

      </template>
    </b-table>

    <!-- AI Analysis Modal -->
    <b-modal id="ai-analysis-modal" ref="aiAnalysisModal" title="AI Analysis" size="lg" hide-footer
      @hide="clearAiAnalysisData">
      <!-- Fixed Review Title -->
      <div class="fixed-review-section" v-if="selectedReviewItem?.title">
        <h5><strong>Review Title:</strong></h5>
        <p><strong>{{ selectedReviewItem.title }}</strong></p>
      </div>

      <!-- Fixed Review Comment -->
      <div class="fixed-review-section" v-if="selectedReviewItem?.review">
        <h5><strong>Review Comment:</strong></h5>
        <p><strong>{{ selectedReviewItem.review }}</strong></p>
      </div>

      <!-- Scrollable AI Analysis -->
      <div class="ai-analysis-content" v-if="selectedReviewItem?.aiAnalysis">
        <div class="scrollable-section">
          <h5><strong>AI Analysis:</strong></h5>
          <pre class="json-display">{{ formattedAiAnalysis }}</pre>
        </div>
      </div>

      <template #modal-footer>
        <b-button variant="secondary" @click="closeAiAnalysisModal">Close</b-button>
      </template>
    </b-modal>

  </div>
</template>

<script>
import * as moment from "moment";
import { MarketplaceService } from "@/services"
require('../style.css')

export default {
  props: {
    sortOptions: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      fields: [
        { key: 'reviewDate', label: 'Review Date', sortable: true },
        { key: 'user', label: 'User Details' },
        { key: 'appName', label: 'App Name' },
        { key: 'totalInstallations', label: 'Total Installations', sortable: true },
        { key: 'rating', label: 'Rating', sortable: true },
        { key: 'title', label: 'Review Title' },
        { key: 'desc', label: 'Review Description' },
        { key: 'aiAnalysis', label: 'AI Analysis' },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'action', label: 'Action' },
      ],
      filters: ["Pending Review", "Approved Review", "Disapproved Review"],
      isLoading: false,
      totalCount: 0,
      ratings: [],
      filterText: 'Pending Review',
      status: 'pending',
      page: 0,
      pageSizes: [10, 20, 50],
      pageSize: 20,
      processing: false,
      searchQuery: '',
      currentSort: {
        field: 'totalInstallations',
        order: 'desc'
      },
      // AI Analysis Modal data
      selectedReviewItem: null,
      showAiAnalysisModal: false
    }
  },
  computed: {
    formattedAiAnalysis() {
      return this.selectedReviewItem?.aiAnalysis
        ? JSON.stringify(this.selectedReviewItem.aiAnalysis, null, 2)
        : '';
    }
  },
  watch: {
    sortOptions: {
      handler(newVal) {
        if (newVal?.sortByInstallations) {
          this.currentSort = {
            field: 'totalInstallations',
            order: newVal.sortOrder
          };
          this.fetchData();
        }
      },
      immediate: true,
      deep: true
    }
  },
  async mounted() {
    await this.changeFilter(0)
  },
  methods: {
    changeFilter(i) {
      this.filterText = this.filters[i]
      switch (this.filters[i]) {
        case 'Disapproved Review': this.status = 'disapproved'
          break
        case 'Approved Review': this.status = 'approved'
          break
        case 'Pending Review':
        default:
          this.status = 'pending'
      }
      this.fetchData()
    },
    nextPage() {
      if (this.totalCount >= (this.page + 1) * this.pageSize) {
        this.page++
        this.fetchData()
      }
    },
    prevPage() {
      if (this.page - 1 > -1) {
        this.page--
        this.fetchData()
      }
    },
    changePage(page) {
      this.page = 0
      this.pageSize = page
      this.fetchData()
    },
    async fetchData() {
      try {
        this.isLoading = true;
        let query = {
          skip: this.pageSize * this.page,
          limit: this.pageSize,
          status: this.status,
          search: this.searchQuery
        }

        // Add sorting parameters
        if (this.currentSort.field === 'totalInstallations') {
          query.sortByInstallations = 'true';
          query.sortOrder = this.currentSort.order;
        }

        this.ratings = []
        const response = await MarketplaceService.getMarketplaceAppRatings(query)
        this.ratings = response.data.reviews || []
        this.totalCount = response.data.count || 0
      } catch (error) {
        console.error(error);
        alert(error.message || error.message[0] || "Something went wrong");
      } finally {
        this.isLoading = false
      }
    },
    async updateStatus(item, status) {
      try {
        this.processing = true
        const response = await MarketplaceService.processReviewComment(item._id, { status, appId: item.appId })
        if (response?.data?.success) {
          const index = this.ratings.findIndex((r) => r._id === item._id);
          if (index > -1) {
            this.ratings.splice(index, 1)
          } else {
            await this.fetchData()
          }
        } else {
          alert("Something went wrong");
        }
      } catch (err) {
        console.log(err)
      } finally {
        this.processing = false
      }
    },
    formatTime(time) {
      return time ? moment(time).format("DD MMM YYYY") : ""
    },
    handleSearch() {
      this.page = 0
      this.fetchData()
    },
    onSort(ctx) {
      if (ctx.sortBy === 'totalInstallations') {
        this.currentSort = {
          field: ctx.sortBy,
          order: ctx.sortDesc ? 'desc' : 'asc'
        };
        this.fetchData();
      }
    },
    // AI Analysis Modal methods
    openAiAnalysisModal(reviewItem) {
      this.selectedReviewItem = reviewItem;
      this.$refs.aiAnalysisModal.show();
    },
    closeAiAnalysisModal() {
      this.$refs.aiAnalysisModal.hide();
    },
    clearAiAnalysisData() {
      this.selectedReviewItem = null;
    }
  }
};
</script>
<style scoped>
.toCapitalFirst {
  text-transform: capitalize;
}

.tag {
  border-radius: 13px;
  color: white;
  text-align: center;
}

.info {
  color: #344054;
  background: #F2F4F7;
  mix-blend-mode: multiply;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}

.success {
  background: #12B76A;
}

.danger {
  background: #D92D20;
}

.form-control {
  min-width: 200px;
}

.filter-bar .btn {
  height: 38px;
  /* Match input height */
}

/* AI Analysis Modal Styles */

/* Fixed sections at the top */
.fixed-review-section {
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e9ecef;
  background-color: white;
  position: relative;
  z-index: 1;
}

.fixed-review-section h5 {
  color: #495057;
  margin-bottom: 0.5rem;
}

.fixed-review-section p {
  margin-bottom: 0;
  padding: 0.5rem;
  background-color: #f8f9fa;
  border-radius: 4px;
  border-left: 4px solid #007bff;
}

/* Scrollable AI Analysis section */
.ai-analysis-content {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  background-color: #fafafa;
}

.scrollable-section {
  padding: 1rem;
}

.scrollable-section h5 {
  color: #495057;
  margin-bottom: 0.5rem;
  margin-top: 0;
}

.json-display {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  padding: 1rem;
  font-family: 'Courier New', Courier, monospace;
  font-size: 14px;
  line-height: 1.4;
  white-space: pre-wrap;
  word-wrap: break-word;
  margin: 0;
}
</style>
